import * as React from 'react';
import { createStore } from '@react-pdf-viewer/core';

const ZoomPlugin = () => {
  const store = React.useMemo(() => createStore(), []);

  return {
    install: pluginFunctions => {
      store.update('zoom', pluginFunctions.zoom);
      store.update('defaultZoomScale', pluginFunctions.getViewerState().scale);
      store.update('zoomSize', 0);
    },
    zoom: zoomSize => {
      const fn = store.get('zoom');
      if (fn) {
        fn(zoomSize);
      }
    },
    // hanjy: 초기 zoom scale 값 가져오기 위한 함수
    getDefaultZoomScale: () => {
      return store.get('defaultZoomScale');
    },
    // hanjy: zoom in/out 공통 함수 정의
    handleZoomInOut: flag => {
      // hanjy: 초기 pdf zoom scale 값을 가져와서, 0 ~ +1 범위까지 확대/축소 가능하도록 설정
      const defaultZoomScale = store.get('defaultZoomScale');
      const zoomSize = store.get('zoomSize');
      let nextZoomSize = zoomSize;
      if (flag === 'p') {
        //확대
        if (zoomSize < 2) {
          nextZoomSize = zoomSize + 1;
        }
      } else if (flag === 'm') {
        if (zoomSize > 0) {
          nextZoomSize = zoomSize - 1;
        }
      }
      if (nextZoomSize !== zoomSize) {
        store.update('zoomSize', nextZoomSize);
        store.get('zoom')(defaultZoomScale + nextZoomSize * 0.5);
      }
    },
  };
};

export default ZoomPlugin;
